import { useEffect, startTransition } from "react";
import { useRouter } from "next/router";

const usePageViewTracking = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      const pageUrl = `https://peerstack.tech${url}`;
      const pageTitle = document.title;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "virtualPageview",
        pageUrl,
        pageTitle,
      });
    };


    startTransition(() => {
      handleRouteChange(router.pathname);
    });

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
};

export default usePageViewTracking;
